/* eslint-disable no-param-reassign */

function customTranslations() {}

export default customTranslations;
